import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Children } from "react";
import Searcher from "../../../index.js";
import { SearcherSkeletonButton } from "../../../searcher-button/skeleton/index.js";
import { Skeleton } from "../../../../../../structures/others/skeleton/index.js";
import { SearcherItem, SearcherItemWithMaxWidth } from "../../../styled.js";
import { SKELETON_DESKTOP_TOP_PROPS as SKELETON_TOP_PROPS } from "../../constants.js";
import * as SS from "../../styled.js";
const renderSkeleton = ({ color , opacity , width ='100%' , height ='56px' , variant ='rectangular'  })=>/*#__PURE__*/ _jsx(Skeleton, {
        variant: variant,
        animation: "wave",
        width: width,
        height: height,
        color: color,
        opacity: opacity
    });
const renderItems = (config, color, opacity)=>{
    const { variants =[]  } = config;
    const finalVariants = Array.isArray(variants) ? variants : new Array(variants).fill({
        variant: 'medium'
    });
    return Children.toArray(finalVariants.map(({ variant , grow =false , withMaxWidth =false , Component  })=>{
        if (Component) {
            return /*#__PURE__*/ _jsx(Component, {
                $variant: variant,
                $grow: grow,
                children: renderSkeleton({
                    color,
                    opacity
                })
            });
        }
        if (withMaxWidth) {
            return /*#__PURE__*/ _jsx(SearcherItemWithMaxWidth, {
                $variant: variant,
                $grow: grow,
                children: renderSkeleton({
                    color,
                    opacity
                })
            });
        }
        return /*#__PURE__*/ _jsx(SearcherItem, {
            $variant: variant,
            $grow: grow,
            children: renderSkeleton({
                color,
                opacity
            })
        });
    }));
};
export const SearcherSkeletonDesktop = ({ config , onModal =false , className =''  })=>{
    const { top , button ={}  } = config.desktop;
    return /*#__PURE__*/ _jsx(SS.SearcherSkeletonWrapper, {
        className: className,
        children: /*#__PURE__*/ _jsxs(Searcher, {
            "data-testid": "SearcherSkeletonDesktop",
            top: top && Children.toArray(Array.from({
                length: top.maxItems
            }).map(()=>{
                const { width , height , variant  } = SKELETON_TOP_PROPS;
                return renderSkeleton({
                    width,
                    height,
                    variant
                });
            })),
            middleProps: {
                $isModal: onModal === true
            },
            children: [
                renderItems(config.desktop),
                /*#__PURE__*/ _jsx(SearcherSkeletonButton, {
                    ...button
                })
            ]
        })
    });
};
export default SearcherSkeletonDesktop;

//# sourceMappingURL=index.js.map